import { Component, OnInit } from "@angular/core";
import { AppConfig } from "../../app-config";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html"
})
export class HeaderComponent implements OnInit {
  constructor(private config: AppConfig) { }

  IsPortal = this.config.IsPortal;
  contactUsPath;
  ngOnInit() {
    if (!this.IsPortal)
      this.contactUsPath = this.config.ContactUsPage
    else
      this.contactUsPath = this.config.PortalContactUsPage

  }
}
